import React from 'react'
import PropTypes from 'prop-types'
import Popover from '@material-ui/core/Popover'
import { DateCalendar } from '@mui/x-date-pickers'
import { DayCalendarSkeleton } from '@mui/x-date-pickers/DayCalendarSkeleton'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import CustomLuxonAdapter from 'lib/CustomLuxonAdapter'
import { defaultFont } from 'themes'
import useStyles from './styles'

const v5Theme = createTheme({
  palette: {
    primary: {
      main: '#00234B',
    },
  },
  typography: {
    fontFamily: defaultFont,
    fontSize: 16,
  },
})

// Full month calendar behind the date strip's calendar button. Changing month
// refetches availability (it is only loaded a month ahead), exactly like the
// calendar on the original time step.
const CalendarPopover = ({
  anchorEl,
  onClose,
  selectedDate,
  onChange,
  onMonthChange,
  shouldDisableDate,
  loading,
}) => {
  const classes = useStyles()
  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      classes={{ paper: classes.calendarPaper }}
    >
      <ThemeProvider theme={v5Theme}>
        <LocalizationProvider dateAdapter={CustomLuxonAdapter}>
          <DateCalendar
            disablePast
            views={['day']}
            value={selectedDate}
            onChange={onChange}
            onMonthChange={onMonthChange}
            shouldDisableDate={shouldDisableDate}
            dayOfWeekFormatter={day => `${day}`}
            loading={loading}
            renderLoading={() => <DayCalendarSkeleton />}
          />
        </LocalizationProvider>
      </ThemeProvider>
    </Popover>
  )
}

CalendarPopover.propTypes = {
  anchorEl: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  selectedDate: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onMonthChange: PropTypes.func.isRequired,
  shouldDisableDate: PropTypes.func.isRequired,
  loading: PropTypes.bool,
}

export default CalendarPopover
